"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
exports.RECAPTCHA_SETTINGS = new core_1.OpaqueToken('recaptcha-settings');



//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/~/ng-recaptcha/recaptcha/recaptcha-settings.js
// module id = ../../../../ng-recaptcha/recaptcha/recaptcha-settings.js
// module chunks = 4